<template>
  <div>
    <div class="flex flex-col gap-y-1">
      <label class="w-full flex gap-0.5 text-brand-black-secondary">
        {{ $t('fileType') }} <span v-if="isRequired" class="text-brand-red">*</span>
      </label>
      <div class="w-full flex gap-x-5">
        <Field :value="1" name="selectFileIdentificater" type="radio" v-slot="{ field }">
          <label class="flex gap-x-2">
            <input
              class="accent-primary"
              type="radio"
              v-bind="field"
              @change="fileValidityStore.resetFileTypeFields(resetField)"
            />
            {{ i18n.t('unifiedNumber') }}
          </label>
        </Field>
        <Field :value="2" name="selectFileIdentificater" type="radio" v-slot="{ field }">
          <label class="flex gap-x-2">
            <input
              class="accent-primary"
              type="radio"
              v-bind="field"
              @change="fileValidityStore.resetFileTypeFields(resetField)"
            />
            {{ $t('FileNumber') }}
          </label>
        </Field>
        <Field
          v-if="values.fileModuleId !== 2"
          :value="3"
          name="selectFileIdentificater"
          type="radio"
          v-slot="{ field }"
        >
          <label class="flex gap-x-2">
            <input
              class="accent-primary"
              type="radio"
              v-bind="field"
              @change="fileValidityStore.resetFileTypeFields(resetField)"
            />
            {{ $t('personEidaNumber') }}
          </label>
        </Field>
      </div>
    </div>
    <!-- if file type is emirate unified number-->
    <Field
      v-if="values.selectFileIdentificater === 1"
      :rules="isRequired"
      name="longUnifiedNumber"
      v-slot="{ field, errors: errs }"
    >
      <SimpleTextInput
        :field="field"
        :errors="errs"
        :label="i18n.t('unifiedNumber')"
        :max-length="12"
        input-class="md:w-1/2 lg:w-1/4"
        direction="flex-col"
        mask="############"
      />
    </Field>

    <!-- if file type is file no -->
    <SimpleFileNumber
      v-if="values.selectFileIdentificater === 2"
      show-part-count-selector
      :show-labels="false"
      :errors
      :values
      :initial-values
      :reset-field
      :set-field-value
    />

    <Field
      v-if="values.selectFileIdentificater === 3"
      :rules="isRequired"
      name="applicantIdentityNumber"
      v-slot="{ field, errors: errs }"
    >
      <SimpleTextInput
        :field="field"
        :errors="errs"
        :label="i18n.t('personEidaNumber')"
        :max-length="15"
        input-class="md:w-1/2 lg:w-1/4"
        direction="flex-col"
        mask="784-####-#######-#"
      />
    </Field>

    <Field :rules="isRequired" name="nationalityId" v-slot="{ field, errors: errs, handleChange }">
      <SimpleDropdown
        :field="field"
        :errors="errs"
        :label="$t('nationality')"
        :options="fileValidityStore.countries"
        direction="flex-col"
        @on-selection="(item) => handleChange(+item?.id)"
      ></SimpleDropdown>
    </Field>
    <Field :rules="isRequired" name="dateOfBirth" v-slot="{ field, errors: errs, handleChange }">
      <SimpleDatepicker
        :field="field"
        :errors="errs"
        :label="$t('DateOfBirth')"
        :default-value="field.value"
        placeholder="yyyy-MM-dd"
        server-date-format="yyyy-MM-dd"
        input-class="ps-3 py-0.5"
        max-date="__now__"
        @on-change="(date) => handleChange(date)"
      >
      </SimpleDatepicker>
    </Field>
  </div>
</template>

<script setup>
import SimpleDatepicker from '@/components/SimpleForm/Datepicker.vue'
import SimpleDropdown from '@/components/SimpleForm/Dropdown.vue'
import SimpleTextInput from '@/components/SimpleForm/TextInput.vue'
import { useFileValidityStore } from '@/stores/file_validity'
import { Field } from 'vee-validate'
import { useI18n } from 'vue-i18n'
import SimpleFileNumber from '@/components/SimpleForm/FileNumber.vue'

defineProps({
  initialValues: { type: Object },
  errors: {
    type: Object
  },
  values: {
    type: Object
  },
  resetField: {
    type: Function
  },
  setFieldValue: {
    type: Function
  }
})

const i18n = useI18n({
  messages: {
    en: {
      unifiedNumber: 'Emirate Unified Number'
    },
    ar: {
      unifiedNumber: 'الرقم الموحد للإمارات'
    }
  }
})

const fileValidityStore = useFileValidityStore()

function isRequired(value) {
  if (value && `${value}`.trim()) {
    return true
  }

  return 'INVALID_REQUIRED'
}
</script>

<style lang="scss" scoped></style>
